import React from 'react';
import { Redirect } from 'react-router-dom';
export default function NewDamagePage() {
  return <Redirect to='/step-pick-car' />;
}
